import React, { useState } from "react";
import PropTypes from "prop-types";
import "./bdiScoreQuestion.css";

const BdiScoreQuestion = ({
  question,
  options = [],
  required = false,
  field,
  value = null,
  updateProgress,
}) => {
  const [touched, setTouched] = useState(false);
  const isEmpty = value === null || value === undefined || value === "";
  const error = required && touched && isEmpty;

  const handleChange = (index) => {
    updateProgress(index);
    setTouched(true);
  };

  const isChecked = (index) => String(value) === String(index);

  return (
    <div className={`bdi-score-question${error ? " error" : ""}`}>
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <div className="bdi-options-container">
        {options.map((option, idx) => (
          <label key={`${field}-${idx}`} className="bdi-option-label">
            <input
              type="radio"
              name={field}
              value={idx}
              checked={isChecked(idx)}
              onChange={() => handleChange(idx)}
              onBlur={() => setTouched(true)}
            />
            {option}
          </label>
        ))}
      </div>
      {error && <p className="error-text">Este campo es obligatorio.</p>}
    </div>
  );
};

BdiScoreQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.bool,
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  updateProgress: PropTypes.func.isRequired,
};

export default BdiScoreQuestion;
